import {
  StyledDescription,
  StyledNameSelector,
  StyledSectionTitle
} from './FilterSetForm.style';
import { FILTER_SET_MODEL } from '../FilterSet.model';
import ErrorMessage from './ErrorMessage';
import { getFilterSetTypeText } from '../filter-set.utils';
import { LBInput } from '@linearb/buzz';

const NameSelector = ({ formState, onChange, validator }) => {
  const typeText = getFilterSetTypeText(formState);

  const placeholder = `My ${typeText}`;

  return (
    <StyledNameSelector>
      <StyledSectionTitle>Display Name</StyledSectionTitle>
      <StyledDescription>
        Provide a clear and descriptive label
      </StyledDescription>
      <LBInput
        name='name'
        value={formState[FILTER_SET_MODEL.NAME]}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={validator.validate}
        data-cy='filter-name-input'
      />
      <ErrorMessage
        validationError={validator.validationError}
        type={FILTER_SET_MODEL.NAME}
      />
    </StyledNameSelector>
  );
};

export default NameSelector;
